/**
 * 上传/下载失败的友好中文文案（P8.12）。
 *
 * ⚠️ 核心意图：fetch 抛出的 TypeError（Chrome「Failed to fetch」、
 *    WebKit「Load failed」）绝不能原样展示给用户。
 *
 * ApiError 保持既有语义（message 已是中文业务文案），
 * 仅对底层 / 非 ApiError 异常做映射。
 */

import { ApiError } from '../../api/client';

export const UPLOAD_NETWORK_ERROR = '上传失败：网络连接中断，请检查网络后重试';
export const UPLOAD_TIMEOUT_ERROR = '上传超时，请重试';

const NETWORK_RE = /failed to fetch|load failed|networkerror|network request failed/i;
const TIMEOUT_RE = /timeout|aborted/i;

export function uploadErrorText(err: unknown, fallback: string): string {
  if (err instanceof ApiError) return err.message || fallback;

  if (err instanceof Error) {
    const message = err.message || '';
    if (NETWORK_RE.test(message)) return UPLOAD_NETWORK_ERROR;
    if (TIMEOUT_RE.test(message)) return UPLOAD_TIMEOUT_ERROR;
    return fallback;
  }

  return fallback;
}
